export const SET_MC_OPS_STATE = "SET_MC_OPS_STATE";
export const SET_MC_OPS_META = "SET_MC_OPS_META";

export const MC_OPS_INIT_STATE = {
  data: {
    jobs: [],
    escalations: [],
    reminders: [],
    notifInternal: [],
    notifExternal: [],
    unanswered24h: { calls: [], texts: [] },
    unanswered48h: { calls: [], texts: [] },
    unansweredOpen: null,
    searchHistory: [],
  },
  meta: {
    loaded: false,
    source: null,
    error: null,
  },
};
